import { useEffect, useState } from 'react';

import { usePriceSettingsHook } from '../../../Hooks/Maintenance/PriceSettings/priceSettingsHooks';

import { Storage } from '../../../Models/Maintenance/PriceSettings/PriceSettings';

import { AutoCompleteDropdownInterface } from '../../../Models/Common/FormFieldComponentInterfaces';

import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';
import GlobalFunctionHelper from '../../../Utilities/Helpers/GlobalFunctionHelper';

import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';
import { CompanyListField, PriceSettingsField } from '../../../Utilities/Enums/ParametersEnum';

import AutoCompleteDropdown from '../AutoCompleteDropdown';

export default function DataStorageDropdown(fieldProps: AutoCompleteDropdownInterface) {
	let {
		name,
		title,
		fieldValue,
		options,
		isLoadingDropdown,
		disabled,
		required,
		errorMessages,
		handleOnChange,
        hideLabel,
        fieldClassName,
        sideContentPosition,
        sideContent,
        currencyCode = GlobalFunctionHelper.getCurrencyCode(),
	} = fieldProps;

	//Use States
    let [initializingStorages, setinitializingStorages] = useState<boolean>(true);
    let [storages, setstorages] = useState<Storage[]>([]);

    const { getPriceSettings } = usePriceSettingsHook([CachingEnum.PRICE_SETTINGS], currencyCode ?? GlobalFunctionHelper.getCurrencyCode(), false);

    const initializeModules = async () => {
        let getCurrencyPriceSettings = await getPriceSettings({ currencyCode: currencyCode });

        setstorages(getCurrencyPriceSettings?.data?.[PriceSettingsField.STORAGES] ?? []);
        setinitializingStorages(false);
    }

    useEffect(() => {
        initializeModules();
    }, [currencyCode]);

    const dataStorageProps = {
        name: name,
        title: title,
        fieldValue: fieldValue,
        options: storages?.map((item: any) => { return { id: item?.[PriceSettingsField.STORAGE] ?? "", name: item?.[PriceSettingsField.STORAGE].toString() }}) ?? [], 
        isLoadingDropdown: initializingStorages,
        disabled: disabled,
        required: required,
        hideLabel: hideLabel,
        errorMessages: errorMessages,
        handleOnChange: handleOnChange,
        fieldClassName: fieldClassName,
        sideContentPosition: sideContentPosition,
        sideContent: sideContent,
    };

    //Rendering Functions
    return <AutoCompleteDropdown {...dataStorageProps} />
}
